var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollaborateicon3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 107.827,
    height: 103.042,
    viewBox: "0 0 107.827 103.042",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2713",
    "data-name": "Group 2713",
    transform: "translate(-1133 -2654)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chat",
    transform: "translate(1103.792 2603.852)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2712",
    "data-name": "Group 2712",
    transform: "translate(29.208 50.148)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4436",
    "data-name": "Path 4436",
    d: "M234.323,125.549h-82.6a12.628,12.628,0,0,0-12.614,12.614V190.1a12.628,12.628,0,0,0,12.614,12.614h57.894a2,2,0,0,1,1.578.765l18.7,23.669a3.726,3.726,0,0,0,2.938,1.441,3.839,3.839,0,0,0,1.262-.215,3.729,3.729,0,0,0,2.536-3.565V202.5a12.672,12.672,0,0,0,10.31-12.4V138.163a12.628,12.628,0,0,0-12.614-12.614ZM242.6,190.1a8.305,8.305,0,0,1-8.169,8.273,2.169,2.169,0,0,0-2.141,2.169v22.643L214.6,200.792a6.312,6.312,0,0,0-4.982-2.414H151.724a8.286,8.286,0,0,1-8.276-8.277V138.163a8.286,8.286,0,0,1,8.276-8.276h82.6a8.286,8.286,0,0,1,8.276,8.276Z",
    transform: "translate(-139.11 -125.549)",
    fill: "#ed1c24"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "star_2_",
    "data-name": "star(2)",
    d: "M30.188,14.445a2.213,2.213,0,0,0-1.227-3.775L21.489,9.585a.976.976,0,0,1-.735-.534l-3.34-6.77a2.213,2.213,0,0,0-3.969,0L10.1,9.051a.977.977,0,0,1-.736.534L1.9,10.671A2.213,2.213,0,0,0,.67,14.445l5.406,5.269a.978.978,0,0,1,.282.865L5.082,28.021a2.213,2.213,0,0,0,3.211,2.333l6.682-3.513a.978.978,0,0,1,.91,0l6.683,3.513a2.213,2.213,0,0,0,3.211-2.333L24.5,20.581a.978.978,0,0,1,.282-.865Zm-6.9,6.344,1.276,7.441a.977.977,0,0,1-1.417,1.031l-6.683-3.514a2.213,2.213,0,0,0-2.06,0L7.718,29.261A.978.978,0,0,1,6.3,28.23l1.276-7.441a2.213,2.213,0,0,0-.636-1.959l-5.407-5.27a.978.978,0,0,1,.541-1.667l7.471-1.086A2.21,2.21,0,0,0,11.211,9.6l3.341-6.77a.978.978,0,0,1,1.753,0L19.646,9.6a2.209,2.209,0,0,0,1.666,1.21l7.472,1.086a.978.978,0,0,1,.541,1.667L23.919,18.83A2.212,2.212,0,0,0,23.283,20.789Z",
    transform: "translate(1172 2677.953)",
    fill: "#ed1c24",
    stroke: "#ed1c24",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollaborateicon3);
export default __webpack_public_path__ + "static/media/collaborateicon3.3c1b6dfdda0984ce8f605888311afdac.svg";
export { ForwardRef as ReactComponent };